import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PILLARS = [
  {
    title: "Designed for movement",
    body: "Recovery isn't stillness. Every LIGATEN piece is built around how bodies actually move — flexion, stride, stretch — so support never asks you to slow down to deserve it.",
    img: "/renders/walk-a.png",
    alt: "Athlete mid-stride in mocha support wear",
  },
  {
    title: "Founder-led by a physiotherapist",
    body: "Every decision starts with someone who has treated real knees, real shoulders, real comebacks. The science leads; the aesthetics make sure you actually want to wear it.",
    img: "/renders/body-1.png",
    alt: "Stretching in mocha support wear",
  },
  {
    title: "Built to be worn, not hidden",
    body: "Most support wear is designed to disappear under clothing. Ours is designed to be seen — recovery as something you wear with intent, not something you conceal with shame.",
    img: "/renders/body-4.png",
    alt: "Profile in mocha back support",
  },
];

export default function PhilosophyPage() {
  return (
    <main data-testid="philosophy-page" className="bg-[#EFE8DC] text-[#2C241E] pt-24">
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
            The Philosophy
          </p>
          <h1
            data-testid="philosophy-page-headline"
            className="font-display text-4xl sm:text-5xl md:text-7xl tracking-tighter leading-[1.02] text-[#2C241E] max-w-4xl"
          >
            Support Should Be Seen.
          </h1>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[#2C241E]/70 max-w-2xl">
            Recovery culture told you to hide. Movement culture celebrates the work. LIGATEN lives
            where the two meet — three beliefs that shape everything we make.
          </p>
        </Reveal>
        <div className="mt-20 space-y-24 md:space-y-32">
          {PILLARS.map((p, i) => (
            <div
              key={p.title}
              data-testid={`pillar-${i + 1}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
            >
              <Reveal className={i % 2 === 0 ? "md:col-span-5" : "md:col-span-5 md:order-2"}>
                <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                  <img src={p.img} alt={p.alt} loading="lazy" className="w-full h-full object-cover" />
                </div>
              </Reveal>
              <div className={i % 2 === 0 ? "md:col-span-6 md:col-start-7" : "md:col-span-6 md:order-1"}>
                <Reveal delay={0.1}>
                  <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#A07856] mb-4">
                    0{i + 1}
                  </p>
                  <h2 className="font-display text-3xl md:text-5xl tracking-tighter text-[#2C241E]">
                    {p.title}
                  </h2>
                  <p className="mt-5 text-base md:text-lg leading-relaxed text-[#2C241E]/70">
                    {p.body}
                  </p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
        <Reveal delay={0.1}>
          <Link
            to="/join"
            data-testid="philosophy-join-link"
            className="mt-20 inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
          >
            Join the list
            <ArrowRight size={16} strokeWidth={1.75} />
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
